module.exports = __webpack_public_path__ + "static/media/iphone.b782bfa3.png";